import React from 'react'
import {Route} from 'react-router'
import Layout from './Layout'
import SSContract from './SSContract'
import Create from './Create'
import DocumentInformation from './DocumentInformation'
import SSSellNote from './SSSellNote'
import SSOperativeData from './SSOperativeData'
import SSICamFields from './SSICamFields'
import SSAnnexedCTO from './SSAnnexedCTO'
import SSSellNoteAdvance from './SSSellNoteAdvance'
import DynamicSellNoteSelect from './DynamicSellNoteSelect'

export default (
  <Route path="/preparation" component={Layout}>
    <Route path="create" component={Create} />
    <Route path=":preparationId/documentinformation" component={DocumentInformation} />
    <Route path=":preparationId/contractFields" component={SSContract} />
    <Route path=":preparationId/sellNoteFields" component={SSSellNote} />
    <Route path=":preparationId/operativeDataFields" component={SSOperativeData} />
    <Route path=":preparationId/iCamFields" component={SSICamFields} />
    <Route path=":preparationId/annexedCTO" component={SSAnnexedCTO} />
    <Route path=":dynamicId/sellNoteAdvance" component={SSSellNoteAdvance} />
    <Route path=":preparationId/dynamicSellNoteSelect" component={DynamicSellNoteSelect} />
  </Route>
)



// WEBPACK FOOTER //
// ./src/App/Pages/Preparation/index.js